import React from 'react'
import { VNCustomerPayingWithCard } from '../components/VNCustomerPayingWithCard'
import { VNCustomerViewingReceiptDialog } from '../components/VNCustomerViewingReceiptDialog'
import { VNTransactionCompleteDialog } from '../components/VNTransactionCompleteDialog'
import { VNTransactionErrorDialog } from '../components/VNTransactionErrorDialog'
import { VNCustomerPaymentDialog } from '../components/VNCustomerPaymentDialog'
import { VNConfirmPaymentDialog } from '../components/VNConfirmPaymentDialog'
import { VNCustomerEnteringTipDialog } from '../components/VNCustomerEnteringTipDialog'
import { VNCardAuthStepOne } from '../components/Auth/VNCardAuthStepOne'
import { VNCardAuthStepTwo } from '../components/Auth/VNCardAuthStepTwo'
import { VNKitchenPrintingModal } from '../components/VNKitchenPrintingModal'
import { VNConnectionRequired } from '../components/VNConnectionRequired'
import { VNCloudPrinterUnavailableOffline } from '../components/General/VNUnavailableOffline'
import { VNBalanceLookupDialog } from '../components/VNBalanceLookupDialog'
import { VNPrinterNotConfiguredDialog } from '../components/VNPrinterNotConfiguredDialog'
import { VNCannotReopenTabDialog } from '../components/VNCannotReopenTabDialog'
import { VNReopenTabDialog } from '../components/VNReopenTabDialog'
import { VNBackBarFinalizeModals } from '../components/Tabs/VNBackBarFinalizeModals'
import VNRichCheckoutDialog from '../components/OpenPrice/VNRichCheckoutDialog'
import VNPriceAdjustmentDialog from '../components/PriceAdjustment/VNPriceAdjustmentDialog'
import VNPriceAdjustExitConfirmation from '../components/PriceAdjustment/VNPriceAdjustExitConfirmation'
import { VNCannotReopenUnsyncedTab } from '../components/VNCannotReopenUnsyncedTab'
import { VNMobileScanPaymentDialog } from '../components/Scan/VNMobileScanPaymentDialog'
import { VNCFDNotPairedDialog } from '../components/VNCFDNotPairedDialog'
import { VNStopSyncWarning } from '../components/VNStopSyncWarning'
import { VNCFDCommunicationErrorDialog } from '../components/VNCFDCommunicationErrorDialog'
import { VNCFDBlockingDialog } from '../components/CFD/VNCFDBlockingDialog'
import { VNConfirmationDialog } from '../components/General/VNConfirmationDialog'
import { VNCFDPairedDialog } from '../components/CFD/VNCFDPairedDialog'
import { VNTipEntryDialog } from '../components/Payment/VNTipEntryDialog'
import { VNEnteringInputDialog } from '../components/General/VNEnteringInputDialog'
import { VNTaxDisplayDialog } from '../components/Taxes/VNTaxDisplayDialog'
import { VNDebugDialog } from '../components/General/VNDebugDialog'
import { VNTabPaymentMethodModal } from '../components/Tabs/VNTabPaymentMethodModal'
import { VNStartATabModal } from '../components/Tabs/VNStartATabModal'
import { TransferTabsSideModal } from '../components/Tabs/VNTransferTabsSideModal'
import { VNConfirmDefaultTipModal } from '../components/Payment/VNConfrimDefaultTipModal'
import { VNCashPaymentAlreadyAppliedModal } from '../components/Payment/VNCashPaymentAlreadyApplied'
import { VNMobileQRReceiptDialog } from '../components/General/VNMobileQRReceiptDialog'

export const VNDialogsContainer = () => {
  return (
    <>
      <VNBackBarFinalizeModals />
      <VNMobileScanPaymentDialog />
      <VNBalanceLookupDialog />
      <VNCustomerPayingWithCard />
      <VNCustomerViewingReceiptDialog />
      <VNConfirmationDialog />
      <VNTransactionCompleteDialog />
      <VNTransactionErrorDialog />
      <VNCustomerPaymentDialog />
      <VNConfirmPaymentDialog />
      <VNCardAuthStepOne />
      <VNCardAuthStepTwo />
      <VNCustomerEnteringTipDialog />
      <VNKitchenPrintingModal />
      <VNCloudPrinterUnavailableOffline />
      <VNConnectionRequired />
      <VNPrinterNotConfiguredDialog />
      <VNCannotReopenTabDialog />
      <VNStopSyncWarning />
      <VNPriceAdjustmentDialog />
      <VNPriceAdjustExitConfirmation />
      <VNReopenTabDialog />
      <VNRichCheckoutDialog />
      <VNCannotReopenUnsyncedTab />
      <VNCFDCommunicationErrorDialog />
      <VNCFDNotPairedDialog />
      <VNCFDBlockingDialog />
      <VNCFDPairedDialog />
      <VNTipEntryDialog />
      <VNTaxDisplayDialog />
      <VNEnteringInputDialog />
      <VNDebugDialog />
      <VNTabPaymentMethodModal />
      <VNStartATabModal />
      <TransferTabsSideModal />
      <VNMobileQRReceiptDialog />
      <VNConfirmDefaultTipModal />
      <VNCashPaymentAlreadyAppliedModal />
    </>
  )
}
